"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ProductHero;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ProductHeroModule = _interopRequireDefault(require("./ProductHero.module.scss"));
var _StickyBanner = _interopRequireDefault(require("./StickyBanner/StickyBanner"));
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ProductHero(props) {
  var eyebrowText = props.eyebrowText,
    title = props.title,
    titleSecondPart = props.titleSecondPart,
    subTitle = props.subTitle,
    BodyCopy = props.BodyCopy,
    secondBodyCopy = props.secondBodyCopy,
    firstCtaGroup = props.firstCtaGroup,
    secondCtaGroup = props.secondCtaGroup,
    brandBackgroundColour = props.brandBackgroundColour,
    heroImage = props.heroImage,
    imageBleedColour = props.imageBleedColour,
    footerCta = props.footerCta,
    footerCopy = props.footerCopy,
    _props$textColourValu = props.textColourValue,
    textColourValue = _props$textColourValu === void 0 ? '#102b2b' : _props$textColourValu,
    _props$textColourName = props.textColourName,
    textColourName = _props$textColourName === void 0 ? 'heritage-green' : _props$textColourName,
    lozengeType = props.lozengeType,
    lozenge = props.lozenge,
    stickyBannerCtaGroup = props.stickyBannerCtaGroup,
    stickyBannerBackgroundColour = props.stickyBannerBackgroundColour,
    StickyBannerCopy = props.StickyBannerCopy,
    stickyBannerLogos = props.stickyBannerLogos,
    footerBackgroundColour = props.footerBackgroundColour,
    _props$removeH = props.removeH1,
    removeH1 = _props$removeH === void 0 ? false : _props$removeH;
  var displayStickyBanner = !!stickyBannerCtaGroup && !!StickyBannerCopy && !!stickyBannerLogos;
  var sectionRef = (0, _react.useRef)(null);
  var bannerRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    bannerIsVisible = _useState2[0],
    setBannerIsVisible = _useState2[1];
  var sectionStyle = {
    '--brandBackgroundColour': brandBackgroundColour,
    '--backgroundImageUrlSmall': "url(".concat(heroImage.mobileImage.url, "?q=70)"),
    '--backgroundImageUrlLarge': "url(".concat(heroImage.desktopImage.url, "?q=70)"),
    '--imageBackgroundColour': imageBleedColour,
    '--footerBackgroundColour': footerBackgroundColour,
    '--textColour': textColourValue,
    '--listItemIconUrl': "url(/productHeroAssets/list-icon-".concat(textColourName, ".svg)")
  };
  var firstCtas = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames["default"])(_ProductHeroModule["default"].buttonGroup, _ProductHeroModule["default"].firstCtaGroup),
    children: firstCtaGroup
  });
  var secondCtas = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames["default"])(_ProductHeroModule["default"].buttonGroup, _ProductHeroModule["default"].secondCtaGroup),
    children: secondCtaGroup
  });
  var footerContainer = /*#__PURE__*/(0, _jsxRuntime.jsx)("footer", {
    className: _ProductHeroModule["default"].footerContainer,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classnames["default"])(_ProductHeroModule["default"].innerContainer),
      children: [footerCta && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames["default"])(_ProductHeroModule["default"].footerCtaWrapper),
        children: footerCta
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames["default"])(_ProductHeroModule["default"].footerCopy),
        children: footerCopy
      })]
    })
  });
  (0, _react.useEffect)(function () {
    if (displayStickyBanner && window !== undefined) {
      (0, _utils.handleBannerVisibility)(sectionRef, window.scrollY, setBannerIsVisible);
      window.addEventListener('resize', function () {
        (0, _utils.handleBannerVisibility)(sectionRef, window.scrollY, setBannerIsVisible);
      });
      window.addEventListener('scroll', function () {
        (0, _utils.handleBannerVisibility)(sectionRef, window.scrollY, setBannerIsVisible);
      });
      return function () {
        window.removeEventListener('resize', function () {
          (0, _utils.handleBannerVisibility)(sectionRef, window.scrollY, setBannerIsVisible);
        });
        window.removeEventListener('scroll', function () {
          (0, _utils.handleBannerVisibility)(sectionRef, window.scrollY, setBannerIsVisible);
        });
      };
    }
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
      ref: sectionRef,
      className: (0, _classnames["default"])(_ProductHeroModule["default"].productHero, _ProductHeroModule["default"][lozengeType], _defineProperty(_defineProperty({}, _ProductHeroModule["default"].hasLozenge, lozenge), _ProductHeroModule["default"].hasStickyBanner, displayStickyBanner)),
      style: sectionStyle,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnames["default"])(_ProductHeroModule["default"].heroContentContainer),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: (0, _classnames["default"])(_ProductHeroModule["default"].innerContainer, _ProductHeroModule["default"].columnsLayout),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: _ProductHeroModule["default"].heroImage
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: _ProductHeroModule["default"].heroContent,
            children: [eyebrowText && (removeH1 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
              className: _ProductHeroModule["default"].eyebrowText,
              children: eyebrowText
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
              className: _ProductHeroModule["default"].eyebrowText,
              children: eyebrowText
            })), (eyebrowText || titleSecondPart) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("h2", {
              className: _ProductHeroModule["default"].title,
              children: [title, titleSecondPart && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: _ProductHeroModule["default"].subTitle,
                children: titleSecondPart
              })]
            }), !eyebrowText && !titleSecondPart && (removeH1 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
              className: _ProductHeroModule["default"].eyebrowText,
              children: title
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
              className: _ProductHeroModule["default"].eyebrowText,
              children: title
            })), !eyebrowText && /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
              className: _ProductHeroModule["default"].title,
              children: subTitle
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: _ProductHeroModule["default"].bodyCopy,
              children: BodyCopy
            }), firstCtaGroup && firstCtaGroup.length > 0 && firstCtas, secondCtaGroup && secondCtaGroup.length > 0 && secondCtas, secondBodyCopy && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: _ProductHeroModule["default"].secondBodyCopy,
              children: secondBodyCopy
            })]
          }), lozenge && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: _ProductHeroModule["default"].filler,
            children: "\xA0"
          }), lozenge && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: _ProductHeroModule["default"].lozenge,
            children: lozenge
          })]
        }), footerContainer]
      })
    }), displayStickyBanner && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: bannerRef,
      className: (0, _classnames["default"])(_ProductHeroModule["default"].bannerContainer, _defineProperty({}, _ProductHeroModule["default"].bannerIsVisible, bannerIsVisible)),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StickyBanner["default"], {
        stickyBannerCtaGroup: stickyBannerCtaGroup,
        StickyBannerCopy: StickyBannerCopy,
        stickyBannerLogos: stickyBannerLogos,
        stickyBannerBackgroundColour: stickyBannerBackgroundColour
      })
    })]
  });
}